module.exports = __webpack_public_path__ + "img/200w.9e1d153b.gif";